
/**
 * @description
 * 로드맵 상세 > 로드맵 수강 과정 > 수업 아이템
 */

import { CLICK_PRODUCT } from '@/utils/amplitudeEvent/amplitudeEvents.js';
import { ROADMAP_SECTION_NAME } from '@/utils/amplitudeEvent/amplitudeSectionNames.js';
import { classTypeEnum, convertClassType } from '@/utils/classType.js';
import { numberToCommaString } from '@/utils/numberString.js';
import { getPathAt } from '@/utils/path.js';

import Icon from '@/components/common/icon/Icon.vue';
import CourseItemTitle from './CourseItemTitle.vue';
import OrderOrFlag from './OrderOrFlag.vue';
import ProfileAndRating from './ProfileAndRating.vue';
import TagList from './TagList.vue';
import ThumbnailItem from './ThumbnailItem.vue';

export default {
  name: 'CourseClassItem',
  components: {
    OrderOrFlag,
    ThumbnailItem,
    TagList,
    CourseItemTitle,
    ProfileAndRating,
    Icon,
  },
  props: {
    order: { type: Number, default: 0 },
    id: { type: Number, default: -1 },
    title: { type: String, default: null },
    thumbnailImage: { type: String, default: null },
    minAge: { type: Number, default: 0 },
    maxAge: { type: Number, default: 0 },
    price: { type: Number, default: 0 },
    teacherName: { type: String, default: null },
    teacherProfileImage: { type: String, default: null },
    reviewRating: { type: Number, default: 0 },
    reviewCount: { type: Number, default: 0 },
    hasSchedule: { type: Boolean, default: false },
    isFull: { type: Boolean, default: false },
    isUse: { type: Boolean, default: false },
    isPublished: { type: Boolean, default: false },
    isPurchased: { type: Boolean, default: false },
    classType: { type: String, default: null },
  },
  data() {
    return {
      classTypeEnum,
      ROADMAP_SECTION_NAME,
    };
  },
  computed: {
    classPrice() {
      return `${numberToCommaString(this.price)}원`;
    },
    convertedClassType() {
      return convertClassType(this.classType);
    },
  },
  methods: {
    logClickEvent() {
      this.logUserCustomEvent(CLICK_PRODUCT, {
        section: ROADMAP_SECTION_NAME.RELATED,
        product_id: this.id,
        at: getPathAt(this.$route),
        class_review_cnt: this.reviewCount,
        class_type: this.classType,
        is_enrolled: this.isPurchased,
      });
    },
  },
};
